import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            探索内容品类
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            六大核心品类，精准定位您感兴趣的内容领域，总有一个值得探索
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center text-center p-5 md:p-6 rounded-2xl bg-background-100 hover:bg-primary-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-background-200 group-hover:bg-primary-100 transition-colors duration-300 mb-3 md:mb-4">
                <i className={`${cat.icon} text-xl md:text-2xl text-secondary-600 group-hover:text-primary-600 transition-colors`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-700 mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <span className="text-xs text-foreground-500">
                {cat.articleCount}篇内容
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}